import { SetupHandlers, SetupServices } from "../runtime.js"
import { promptTemplateDestination } from "./prompts.js"

export function createContainerHandlers(services: SetupServices): SetupHandlers {
  return {
    async SELECT_TEMPLATE_DESTINATION(context) {
      services.ui.renderStep("Container destination")
      if (!context.templateFramework) services.ui.error("Template framework is missing.")
      const templateDestinationPath = await promptTemplateDestination({
        defaultDestinationPath: context.templateDestinationPath,
        error: services.ui.error,
        framework: context.templateFramework,
        log: services.ui.log,
      })
      return { templateDestinationPath }
    },
    async PREPARE_TEMPLATE(context) {
      services.ui.renderStep("Container setup")
      if (!context.templateFramework || !context.templateDestinationPath) {
        services.ui.error("Template context is incomplete.")
      }

      await services.container.ensureTemplateRepository(context.templateFramework, context.templateDestinationPath)
      services.ui.renderTemplateReadyCard(context.templateDestinationPath)
      return undefined
    },
  }
}
